import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"

function SEO({ description, lang, meta, image, imageAlt, title }) {
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      meta={[
        //HTML/BASIC
        {
          name: `description`,
          content: description,
        },

        //OPEN-GRAPH
        {
          property: `og:type`,
          content: "website",
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: description,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `og:image`,
          content: image,
        },
        {
          name: `og:image:secure_url`,
          content: image,
        },
        {
          name: `og:image:alt`,
          content: imageAlt,
        },
        {
          name: `og:image:type`,
          content:
            image && image.indexOf(".png") !== -1 ? "image/png" : "image/jpeg",
        },
        {
          name: `og:image:width`,
          content: "1200",
        },
        {
          name: `og:image:height`,
          content: "630",
        },

        //TWITTER
        {
          name: `twitter:card`,
          content: `summary_large_image`,
        },
        {
          name: `twitter:site`,
          content: "@soundcomply",
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: description,
        },
        {
          name: `twitter:image`,
          content: image,
        },
        {
          name: `twitter:image:alt`,
          content: imageAlt,
        },
      ].concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
